import { IManufacturer } from '@models/Manufacturer.model';
import { IProduct } from '@models/Product.model';

import { Icon as BlueIcon } from '@blueprintjs/core';

import ReactDom from 'react-dom';

import { useEffect, useRef, useState as classicUseState } from 'react';

import FormControlLabel from '@material-ui/core/FormControlLabel';

import CheckBox from '@assets/svg/checkbox.svg';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { withStyles } from '@material-ui/core';
import { blue } from '@material-ui/core/colors';
import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox';
import { extractUrl, getFilterRequest, isImageUrl } from '@utils';
import { IPaginationResult } from '@models/Equipment.model';
import { useMutation, useQuery } from 'react-query';
import { getProducts } from '@services/queries/products';

import SearchNotificationImage from '@assets/svg/search-notification.svg';
import {
  Close,
  LoadingImg,
  SearchButton,
} from '@pages/Products/Products.styles';
import Rolling from '@assets/gif/rolling.gif';
import CloseImage from '@assets/svg/close.svg';

import { FilterProduct } from '@components';

import {
  indexDocumentProducts,
  patchDocument,
} from '@services/queries/documents';

import { State } from '@hookstate/core';
import {
  ShowSelectedFields,
  ListProductsWithToggle,
} from '@pages/Asset/components/Documents/Components/AddDocuments/components';

import { IProductFilterData } from '@components/Filters/FilterProduct/types';
import { noop } from '@utils/noop';
import { IDocument, IDocumentTable } from '@models/Document.model';

import {
  AssociateText,
  InputDiv,
  CheckCircle,
  Label,
  RowDiv,
  UncheckCircle,
  InputText,
  Container,
  Buttons,
  Cancel,
  RowContainer,
  Confirm,
  SelectFile,
  FileName,
  Header2,
  Title,
  IconCloseAwesome,
  Overlay,
  Close2,
  DocOriginDiv,
  Divider,
  TextArea,
  Body,
  Search,
  SearchContainer,
  SearchImg,
} from './EditDocument.styles';

const BlueCheckbox = withStyles({
  root: {
    color: blue[300],
    '&$checked': {
      color: blue,
    },
  },
  checked: {},
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);
interface ContactProps {
  manufacturerData?: IManufacturer;
  productData?: IProduct;
  openEditDocument: State<boolean>;

  onSuccess?: VoidFunction;

  selectedDocument: IDocument | IDocumentTable | null;
}
/**
 * # Note
 *  This should only be called with a manufacturer (and product), else it may edit unintended data. See mutationEditDocument.mutate
 */
const EditDocument = (props: ContactProps) => {
  const {
    manufacturerData,
    productData,
    openEditDocument,
    selectedDocument,
    onSuccess = noop,
  } = props;
  const portalDiv = document.getElementById('portal');

  const productView = productData;
  const [data, setData] = classicUseState<
    IPaginationResult<IProduct> | undefined
  >(
    productView
      ? {
          totalPages: 1,
          currentPage: 1,
          results: [productView],
          hasMore: false,
          total: 1,
        }
      : undefined,
  );
  const [page, setPage] = classicUseState(1);
  const [filter, setFilter] = classicUseState({
    modelsName: [],
    manufactorNames: [],
  } as IProductFilterData);
  const [dataSelected, setDataSelected] = classicUseState<IProduct[]>(
    productView ? [productView] : [],
  );
  const [loadingSearch, setLoadingSearch] = classicUseState(false);
  const [alreadySearch, setAlreadySearch] = classicUseState(false);
  const [showErasedSearch, setShowErased] = classicUseState(false);

  const [label, setLabel] = classicUseState(selectedDocument?.label || '');
  const [description, setDescription] = classicUseState(
    selectedDocument?.description || '',
  );
  const [url, setUrl] = classicUseState(
    selectedDocument?.uri?.split('?')[0] || '',
  );

  const documentOne = selectedDocument;

  const documentProductsQuery = useQuery(
    ['documents', documentOne?.id, 'products'],
    () => indexDocumentProducts(documentOne?.id),
  );

  useEffect(() => {
    setLabel(selectedDocument?.label || '');
    setDescription(selectedDocument?.description || '');
    setUrl(extractUrl(selectedDocument?.uri || ''));
  }, [selectedDocument]);

  const getProductsWithSearch = useMutation(getProducts, {
    onSuccess: newData => {
      setLoadingSearch(false);
      setShowErased(true);
      setAlreadySearch(true);
      setPage(newData.currentPage);
      // Todo: Sort and map instead.

      if (data && newData.currentPage > 1) {
        const resultsContacted = data.results.concat(newData.results);
        setData({
          total: newData.total,
          currentPage: newData.currentPage,
          totalPages: newData.totalPages,
          hasMore: newData.hasMore,
          results: resultsContacted,
        });
      } else
        setData({
          total: newData.total,
          currentPage: newData.currentPage,
          totalPages: newData.totalPages,
          hasMore: newData.hasMore,
          results: newData.results,
        });
    },
    onError: () => {
      setLoadingSearch(false);
      setShowErased(true);
    },
  });
  const [searchText, setSearchText] = classicUseState('');
  const [associateTo, setAssociateTo] = classicUseState<
    'product' | 'manufacturer' | 'global'
  >('product');

  const [file, setFile] = classicUseState<File | undefined>(undefined);
  const searchFunc = (input: string) => {
    setShowErased(false);
    setSearchText(input);
  };
  const clearStates = () => {
    setUrl('');
    setLabel('');
    setSearchText('');
    setDescription('');
    setDataSelected(productView ? [productView] : []);
    setLoadingSearch(false);
    setShowErased(false);
    setAlreadySearch(false);
    setFile(undefined);
    setAssociateTo('product');
  };
  const mutationAddContact = useMutation(patchDocument, {
    onSuccess: () => {
      clearStates();
      onSuccess();
      openEditDocument.set(false);
    },
  });

  const updateDataSelected = (productsArray?: IProduct[]) => {
    if (!productsArray) return;
    if (productsArray.length === 1) {
      const newProduct = productsArray[0];
      const selected =
        dataSelected.length > 0
          ? dataSelected.find(d => d.id === newProduct.id)
          : undefined;
      if (!selected) {
        setDataSelected(dataSelected.concat([newProduct]));
        return;
      }
      setDataSelected(dataSelected.filter(d => d.id !== newProduct.id));
    } else {
      const productsNotSelected = productsArray.filter(
        product =>
          dataSelected.find(selected => product.id === selected.id) ===
          undefined,
      );
      if (productsNotSelected.length > 0) {
        setDataSelected([...dataSelected, ...productsNotSelected]);
        return;
      }
      setDataSelected([]);
    }
  };

  const startSearch = (input?: string) => {
    setLoadingSearch(true);

    getProductsWithSearch.mutate({
      pagination: {
        page: 1,
        limit: 20,
        search: input !== undefined ? input : searchText,
      },
      filter: { ...getFilterRequest(filter, true), filterByEquipment: true },
    });
  };
  const onPressEnter = (event: any) => {
    if (event.key === 'Enter') {
      startSearch(searchText);
    }
  };
  const loadMore = (input?: string) => {
    if (data?.hasMore)
      getProductsWithSearch.mutate({
        pagination: {
          page: page + 1,
          limit: 20,
          search: input === undefined ? searchText : input,
        },
        filter: { ...getFilterRequest(filter, true), filterByEquipment: true },
      });
  };
  const inputFile = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (documentOne) {
      if (documentOne.isGlobal) {
        setAssociateTo('global');
      } else if (documentOne.manufacturerId) {
        setAssociateTo('manufacturer');
      } else {
        setAssociateTo('product');
      }
    }
  }, [selectedDocument]);

  useEffect(() => {
    if (documentOne) {
      if (!documentOne.isGlobal && !documentOne.manufacturerId) {
        if (documentProductsQuery.data) {
          setDataSelected(documentProductsQuery.data);
          setData({
            totalPages: 1,
            currentPage: 1,
            results: documentProductsQuery.data,
            hasMore: false,
            total: 1,
          });
        }
      }
    }
  }, [documentOne, documentProductsQuery.data]);

  if (!manufacturerData) {
    return <div>Manufacturer missing</div>;
  }

  return openEditDocument && portalDiv
    ? ReactDom.createPortal(
        <Overlay>
          <Container>
            <Header2>
              <Title>Edit Document</Title>
              <Close2 onClick={() => openEditDocument.set(false)}>
                <BlueIcon icon="cross" color="#8f95b2" />
              </Close2>
            </Header2>

            <Body>
              <InputDiv style={{ marginLeft: 0 }}>
                <Title className="label">Document Name</Title>
                <Divider height="8px" />
                <InputText
                  value={label}
                  onChange={e => {
                    setLabel(e.target.value);
                  }}
                  placeholder="EX: Local Service Contact"
                />
              </InputDiv>

              <Divider height="16px" />

              <Title className="label">Document File or URL</Title>
              <Divider height="8px" />
              <DocOriginDiv>
                <InputText
                  value={extractUrl(url)}
                  onChange={e => {
                    setUrl(e.target.value);
                  }}
                  isLink={isImageUrl(url)}
                  placeholder="EX: document.com/your-document"
                  type="url"
                />

                <input
                  type="file"
                  id="file"
                  ref={inputFile}
                  style={{ display: 'none' }}
                  onChange={input => {
                    setFile(input?.target?.files?.[0]);
                  }}
                />
                {file ? (
                  <FileName>
                    {file.name}
                    <IconCloseAwesome
                      icon={faTimes}
                      onClick={() => setFile(undefined)}
                    />
                  </FileName>
                ) : (
                  <SelectFile
                    onClick={() => {
                      inputFile?.current?.click();
                    }}
                  >
                    Select File
                  </SelectFile>
                )}
              </DocOriginDiv>

              <Divider height="16px" />

              <Title className="optional">
                Document Descriptions (Optional)
              </Title>
              <Divider height="8px" />
              <TextArea
                placeholder="Document URL or Select a File"
                value={description}
                onChange={e => {
                  setDescription(e.target.value);
                }}
              />

              <Divider height="16px" />

              <Title className="associate">Associate to</Title>
              <div
                style={{
                  flexDirection: 'row',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                  marginBottom: 8,
                  width: '100%',
                }}
              >
                <RowDiv>
                  <FormControlLabel
                    style={{ margin: 0 }}
                    control={
                      <BlueCheckbox
                        icon={<UncheckCircle />}
                        checkedIcon={
                          <CheckCircle src={CheckBox} alt="CheckBox" />
                        }
                        name="checkedH"
                      />
                    }
                    label=""
                    checked={associateTo === 'product'}
                    onClick={() => setAssociateTo('product')}
                  />
                  <Label>Product</Label>
                </RowDiv>
                <RowDiv>
                  <FormControlLabel
                    style={{ margin: 0 }}
                    control={
                      <BlueCheckbox
                        icon={<UncheckCircle />}
                        checkedIcon={
                          <CheckCircle src={CheckBox} alt="CheckBox" />
                        }
                        name="checkedH"
                      />
                    }
                    label=""
                    checked={associateTo === 'manufacturer'}
                    onClick={() => setAssociateTo('manufacturer')}
                  />
                  <Label>Manufacturer</Label>
                </RowDiv>
                <RowDiv>
                  <FormControlLabel
                    style={{ margin: 0 }}
                    control={
                      <BlueCheckbox
                        icon={<UncheckCircle />}
                        checkedIcon={
                          <CheckCircle src={CheckBox} alt="CheckBox" />
                        }
                        name="checkedH"
                      />
                    }
                    label=""
                    checked={associateTo === 'global'}
                    onClick={() => setAssociateTo('global')}
                  />
                  <Label>Global</Label>
                </RowDiv>
              </div>
              {associateTo === 'global' && (
                <AssociateText>
                  This document will be available for any product or
                  manufacturer.
                </AssociateText>
              )}
              {associateTo === 'manufacturer' && (
                <AssociateText>
                  {`This document will be available for ${manufacturerData?.name} products.`}
                </AssociateText>
              )}

              {associateTo === 'product' && (
                <AssociateText>
                  This document will be available for any of the selected
                  product.
                </AssociateText>
              )}
              {associateTo === 'product' && (
                <>
                  <div
                    style={{
                      flexDirection: 'row',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: '100%',
                    }}
                  >
                    <RowContainer>
                      <SearchContainer>
                        <SearchImg src={SearchNotificationImage} alt="search" />
                        <Search
                          value={searchText}
                          placeholder="Search Products"
                          onChange={e => searchFunc(e.target.value)}
                          onKeyDown={onPressEnter}
                        />
                        {loadingSearch && (
                          <LoadingImg src={Rolling} alt="loading" />
                        )}
                        {showErasedSearch &&
                          searchText.length > 0 &&
                          !loadingSearch && (
                            <Close
                              src={CloseImage}
                              alt="close"
                              onClick={async () => {
                                await searchFunc('');
                                startSearch('');
                              }}
                            />
                          )}
                        {!loadingSearch &&
                          !showErasedSearch &&
                          (searchText.length > 0 || alreadySearch) && (
                            <SearchButton onClick={() => startSearch()}>
                              Search
                            </SearchButton>
                          )}
                      </SearchContainer>
                      <FilterProduct
                        filterData={filter}
                        setFilterData={setFilter}
                        startSearch={startSearch}
                      />
                    </RowContainer>
                    {dataSelected.length > 0 && (
                      <ShowSelectedFields
                        listOfProducts={dataSelected}
                        setListOfProducts={setDataSelected}
                      />
                    )}
                  </div>

                  <ListProductsWithToggle
                    data={data?.results}
                    total={data?.total}
                    dataSelected={dataSelected}
                    loadMore={() => loadMore()}
                    hasMore={data?.hasMore}
                    isLoading={
                      loadingSearch ||
                      !documentProductsQuery ||
                      documentProductsQuery.isLoading
                    }
                    updateDataSelected={updateDataSelected}
                  />
                </>
              )}
            </Body>

            <Divider height="24px" />
            <Buttons>
              <Title className="description">
                Tip: At least one Phone Number or Email need to be added, but
                having both is not required.{' '}
              </Title>
              <Divider width="16px" />
              <Cancel
                onClick={() => {
                  clearStates();
                }}
              >
                Clear
              </Cancel>
              <Divider width="8px" />
              <Confirm
                disabled={
                  label.length === 0 ||
                  (associateTo === 'product' && dataSelected.length === 0)
                }
                onClick={() => {
                  const documentId = selectedDocument?.id;

                  const canSubmit = () => {
                    if (associateTo === 'product') {
                      if (dataSelected.length === 0) {
                        return false;
                      }
                    }

                    return true;
                  };

                  if (documentId && canSubmit()) {
                    mutationAddContact.mutate({
                      data: {
                        documentId,
                        manufacturerId:
                          associateTo === 'manufacturer'
                            ? manufacturerData?.id
                            : undefined,
                        productIds:
                          associateTo === 'product'
                            ? dataSelected.map(item => item.id)
                            : undefined,
                        haveOwnerStudio: true,
                        isGlobal: associateTo === 'global' ? 'true' : 'false',
                        uri: url,
                        label,
                        file,
                        description,
                      },
                    });
                  }
                }}
              >
                Save
              </Confirm>
            </Buttons>
          </Container>
        </Overlay>,
        portalDiv,
      )
    : null;
};

export { EditDocument };
